module.exports = __webpack_public_path__ + "img/threads.874b17e5.png";